import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';

export default function Contact() {
  const email = 'contacto@arburola.com';
  const subject = encodeURIComponent('Contacto desde MotoMarket CR');
  const mailtoLink = `mailto:${email}?subject=${subject}`;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <Link to="/" className="flex items-center gap-2 text-primary mb-6 hover:underline">
          <ArrowLeft className="w-5 h-5" />
          Volver al inicio
        </Link>

        <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
          <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Mail className="w-10 h-10 text-primary" />
          </div>
          
          <h1 className="text-3xl font-black mb-4">
            <span className="text-primary">Contáctanos</span>
          </h1>
          
          <p className="text-gray-600 text-lg mb-8">
            ¿Tienes preguntas o necesitas ayuda? Envíanos un correo y te responderemos en un máximo de 24-48 horas.
          </p>

          <a
            href={mailtoLink}
            className="inline-flex items-center gap-3 bg-primary text-white font-bold px-8 py-4 rounded-xl hover:bg-orange-600 transition text-xl"
          >
            <Mail className="w-6 h-6" />
            {email}
          </a>

          <div className="mt-8 pt-8 border-t border-gray-100">
            <p className="text-gray-500 text-sm">Horario de atención</p>
            <p className="text-gray-700 font-medium">Lunes a Viernes: 8:00 AM - 6:00 PM</p>
            <p className="text-gray-700 font-medium">Sábados: 9:00 AM - 2:00 PM</p>
          </div>
        </div>
      </div>
    </div>
  );
}
